import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageRequest, PaginationPage } from 'src/app/common/modules/data-table.module/interfaces';
import { EAppointmentState } from 'src/app/entities/appointment.entity';
import { DoctorAppointment } from 'src/app/entities/appointment.entity/doctor-appointment.entity/doctor-appointment';
import { EDalyTimeSlotLocation } from 'src/app/entities/daly-time-slot.entity/daly-time-slot';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doctor-appointments-card',
  templateUrl: './doctor-appointments-card.component.html',
  styleUrls: ['./doctor-appointments-card.component.css']
})
export class DoctorAppointmentsCardComponent implements OnInit {
  @Input() currentPage: number = 0;
  @Input() perPage: number = 10;
  @Input() pageRequest!: (pageRequest: PageRequest) => Promise<PaginationPage<DoctorAppointment>>;

  doctorAppointments: Array<DoctorAppointment> = new Array();


  @Output() onEditRequest: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onPatientProfileRequest: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onAssignPrescriptionRequest: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onAssignConsultationRequest: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onViewPrescriptionRequest: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onViewConsultationRequest: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onViewAttachmentsRequest: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onViewAttestationsRequest: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onAffect: EventEmitter<DoctorAppointment> = new EventEmitter();

  @Output() onViewTeleConsultationRequest: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onAccept: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onReject: EventEmitter<DoctorAppointment> = new EventEmitter();
  @Output() onBillingRequest: EventEmitter<DoctorAppointment> = new EventEmitter();

  @Input() actions: Partial<{ accept: boolean, reject: boolean, edit: boolean, delete: boolean, prescription: boolean, consultations: boolean, attachmentsView: boolean, payementsView: boolean, attestation: boolean, affect: boolean }> = {}
  constructor(private authService:AuthService) { }

  ngOnInit(): void {
    this.currentPage = 0;
  }
get doctor():Doctor{
  return new Doctor(this.authService.getCurrentUser() !)
}
 avatarSrc(doctorAppointment: DoctorAppointment): string {
    return doctorAppointment.patientImageProfile ? `http${environment.API_SSL ? 's' : ''}://${environment.API_HOST_NAME}${environment.PORT ? ':' + environment.PORT : ''}/${environment.STORAGE_ENDPOINT}/${doctorAppointment.patientImageProfile}` : 'assets/img/user-avatar.png';
  }
  canOpenTeleconsultation(appointment: DoctorAppointment): boolean {
    return appointment.status == EAppointmentState.ACCEPTED && (appointment.location == EDalyTimeSlotLocation.BOTH || appointment.location == EDalyTimeSlotLocation.ONLINE)
  }

  canAssignPrescription(appointemnt: DoctorAppointment): boolean {
    return !appointemnt.hasPrescription
  }
}
